import React from 'react';
import SiteManagementRouter from './SiteManagementRouter';

export default function SiteManagementPage() {
  return <SiteManagementRouter />;
}
